// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 218) return "static/chunks/218.7be35609470e90f8.js";
	if (chunkId === 4491) return "static/chunks/4491.cb0406633ae18098.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5730 ? "44530001" : chunkId) + "-" + {"1583":"cc48fe799f1b91d2","3850":"69678ef8a2030b20","5730":"036bc5f39a045027","6010":"6a4f933b393d869e","7817":"ddbe0cc6122103aa"}[chunkId] + ".js";
};